module.exports = __webpack_public_path__ + "img/bg-cone.614219c5.jpg";